<!-- Alert -->
<p-toast key="main"
  position="top-center"
  showTransformOptions="translateY(-100%)">
  <ng-template let-message pTemplate="message">
    <span
      [class]="'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')"
      [ngClass]="{ 'pi-info-circle': message.severity === 'info', 'pi-exclamation-triangle': message.severity === 'warn', 'pi-times-circle': message.severity === 'error', 'pi-check': message.severity === 'success' }"
    ></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" [innerHTML]="message.detail"></div>
    </div>
  </ng-template>
</p-toast>

<!-- General modal -->
<medsurf-general-modal></medsurf-general-modal>

<!-- Cookies -->
@if ((menuSharedFacade.showPrint$ | async) === false) {
  <medsurf-cookie-consent></medsurf-cookie-consent>
}

<!-- Notice -->
<medsurf-notice [includes]='["elearnings", "chapters", "subchapters", "blocks"]'></medsurf-notice>

<div class="router-container" [class.blur-35]="modalControlService.showModal || feedbackControlService.showFeedbackModal">
  <!-- Navbar-->
  @if ((menuSharedFacade.showFullscreen$ | async) === false && (menuSharedFacade.showPrint$ | async) === false) {
    <medsurf-navbar></medsurf-navbar>
  }

  <!-- Spinner -->
  @if (isLoader) {
    <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
  }

  <!-- Router Outlet -->
  <router-outlet></router-outlet>

  <!-- footer -->
  <!--
  <medsurf-footer class="d-none d-md-inline"
    [links]="footerLinks"
    align="center">
  </medsurf-footer>
  -->
</div>

<!-- Modal -->
<medsurf-modal></medsurf-modal>

<!-- Feedback -->
@if (feedbackControlService.showFeedbackModal) {
  <medsurf-feedback></medsurf-feedback>
}
